import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VbVideoBannersComponent } from 'vbrick-player-src/videoBanner/VbVideoBanners.Component';

import { NativeHlsStallDetectorDirective } from './NativeHlsStallDetector';
import { SafeStyleComponent } from './SafeStyle.Component';
import { VbMediaClickDirective } from './VbMediaClick.Directive';
import { VgChapterDisplayComponent } from './VgChapterDisplay.Component';
import { VgFullscreenService } from './VgFullscreen.Service';
import { VgMediaComponent } from './VgMedia.Component';
import { VgUtilsService } from './VgUtils.Service';
import { VideogularComponent } from './Videogular.Component';

const components = [
	VbVideoBannersComponent,
	VgChapterDisplayComponent,
	VgMediaComponent,
	VideogularComponent
];

const directives = [
	NativeHlsStallDetectorDirective,
	VbMediaClickDirective
];

//TODO: Only export needed components.
const componentsAndDirectives = [...components, ...directives];

@NgModule({
	declarations: [...componentsAndDirectives, SafeStyleComponent],
	exports: componentsAndDirectives,
	imports: [
		CommonModule
	],
	providers: [
		VgFullscreenService,
		VgUtilsService
	]
})
export class VideogularModule {}
